import React, { useState, useEffect, useCallback } from 'react';
import GoogleMapReact from 'google-map-react';
import { useHistory } from 'react-router-dom';
import useApi from '../../api/useApi';
import '../../scrollbar.css';
import ShowZone from '../../components/ShowZone';

function Table() {
  const user = localStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(localStorage.user).organization.id;
  const [openCreate, setOpenCreate] = useState(false);
  const [{ isLoading, isError, data }] = useApi();
  const [zones, zoneData] = useApi();
  const [zone, setzone] = useState([]);
  const [openZone, setOpenZone] = useState(false);
  const [id, setId] = useState(null);
  const history = useHistory();
  const [center, setCenter] = useState({
    lat: 32.874525,
    lng: -117.2160221,
  });
  const [coordinates, setCoordinates] = useState([center]);
  const [cor, setCor] = useState([]);

  useEffect(() => {
    user && zoneData(`/organization/${orgId}/zones`, 'GET');
  }, []);

  useEffect(() => {
    if (!zones.isLoading && !zones.isError && zones.data) {
      const zonesFiltered = zones.data.filter((zone) => zone.location !== null);
      const _zones = zonesFiltered.sort((a, b) => (a.location.toLowerCase() > b.location.toLowerCase() ? 1 : -1));
      setzone(_zones);
      for (let i = 0; i < _zones.length; i++) {
        if (_zones[i].gateways.length > 0 && _zones[i].gateways[0].latitude && _zones[i].gateways[0].longitude) {
          cor.push({
            lat: parseFloat(_zones[i].gateways[0].latitude),
            lng: parseFloat(_zones[i].gateways[0].longitude),
          });
        }
      }
      setCoordinates(cor);
    }
  }, [zones.isLoading, zones.isError, zones.data]);

  const getMapOptions = (maps) => {
    return {
      streetViewControl: false,
      scaleControl: true,
      fullscreenControl: true,
      gestureHandling: 'greedy',
      disableDoubleClickZoom: true,
      minZoom: 1,

      mapTypeControl: true,
      mapTypeControlOptions: {
        style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: maps.ControlPosition.BOTTOM_CENTER,
        mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE, maps.MapTypeId.HYBRID],
      },

      zoomControl: true,
      clickableIcons: true,
    };
  };

  const handlegoogleApi = (map, maps, places) => {
    const markers = [];
    const bounds = new maps.LatLngBounds();
    places.forEach((place, idx) => {
      markers.push(
        new maps.Marker({
          position: { lat: place.lat, lng: place.lng },
          icon: 'assets/img/marker.svg',
          map,
          title: `(${zone[idx]?.location}, ${place.lat}, ${place.lng})`,
        })
      );
      if (place.lat && place.lng)
        bounds.extend(place);
    });
    map.fitBounds(bounds);
    bounds.getCenter();
  };

  const toggleOpenZone = (prev) => {
    setOpenZone((prev) => !prev);
  };

  return (
    <>
      <div
        className="h-full w-topBar fixed hideScroll m-8 w-full left-44"
        style={{ filter: openCreate && 'blur(2px)', overflow: 'auto', left: '14%', width: '81%' }}
      >
        <div className="w-full h-screen" style={{ height: '94vh' }}>
          {!openZone && cor.length > 0 &&
            <GoogleMapReact
              key={coordinates}
              bootstrapURLKeys={{ key: 'AIzaSyDVsc9GqAbD6BF7vKPaLTNgtFFksrxj0Yw' }}
              options={getMapOptions}
              defaultZoom={3}
              defaultCenter={center}
              onGoogleApiLoaded={({ map, maps }) => handlegoogleApi(map, maps, coordinates)}
            />
          }
        </div>
        <div className="absolute z-50 w-full top-12 flex">
          {!isLoading &&
            <div className="exampleZones border bg-tableBg absolute h-screen shadow-md max-w-screen-xl mx-auto w-auto w-1/5">
              <h1 className="text-lg font-bold bg-white px-6 py-3">Zones</h1>
              <div
                className="pb-1 hideScroll"
                style={{ borderColor: '#e6e6e6', height: '78vh', overflow: 'auto', borderBottom: 'none' }}
              >
                {zone.map((item, idx) => (
                  <div
                    className="m-2 px-4 bg-white flex rounded-md
                  shadow-sm relative border hover:border-indigo-200 focus-within:border-indigo-200"
                  >
                    <div className=" py-1 text-xs w-full">
                      <a
                        href="#"
                        className="font-bold text-textBlue1 capitalize text-sm"
                        onClick={(e) => {
                          setId(e.target.id);
                          setOpenZone(true);
                        }}
                        id={idx}
                      >
                        {` ${item.location !== null ? item.location : 'undefined'}`}
                      </a>
                      <div className="flex my-0 mt-1 text-textBlack">
                        {item?.geoLocation}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          }
          {isLoading && <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />}

          {
            openZone && <div className="border absolute bg-white" style={{ width: '78%', left: '21%', height: '83vh' }}><ShowZone gatewayData={zone[id]} handleClose={toggleOpenZone} /></div>
          }
        </div>
      </div>
    </>
  );
}

export default Table;
